import { Spinner, Stack } from "react-bootstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ServiceManager } from "../../../../services/ServiceManager";
import { APIStatusCode, ExtractClientStatus, ExtractClientStatusLabels, ExtractClientStatusConfirmMessages } from "../../../../app/enums";
import { handleApiErrors } from "../../../../app/common/helper/ApiError";
import MISButton from "../../../../components/button";

interface ChangeStatusModalProps {
    establishmentId: string | undefined;
    configurationId: number;
    pendingStatus: ExtractClientStatus | null;
    tableQueryKey: string;
    onClose: () => void;
}

export default function ChangeStatusModal({ establishmentId, configurationId, pendingStatus, tableQueryKey, onClose }: ChangeStatusModalProps) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: () => {
            return ServiceManager.ConfigurationService.UpdateExtractClientStatus(establishmentId, configurationId, pendingStatus!);
        },
        onError: () => {
            ServiceManager.ToastService.showError("Unable to update extract client status.");
        },
        onSuccess: (data) => {
            if (data === null) {
                ServiceManager.ToastService.showError("Unable to update extract client status.");
            } else {
                if (data.status === APIStatusCode.Ok || data.status === APIStatusCode.NoContent) {
                    ServiceManager.ToastService.showSuccess("Extract Client status updated successfully.");
                    queryClient.invalidateQueries({ queryKey: [tableQueryKey] });
                    onClose();
                } else {
                    handleApiErrors(data, ServiceManager.ToastService);
                }
            }
        }
    });

    const getStatusTitle = () => {
        if (pendingStatus === null) return "Change Status";
        return `Change to ${ExtractClientStatusLabels[pendingStatus]}`;
    };

    return (
        <Stack>
            <p className="heading text-center mt-2">{getStatusTitle()}</p>
            <p className="text-center">
                {pendingStatus !== null ? ExtractClientStatusConfirmMessages[pendingStatus] : ""}
            </p>
            {
                !mutation.isPending
                    ? (<Stack direction="horizontal" className="mt-3">
                        <MISButton text="Cancel" className="popup-btn right-margin10 btn btn-outline-secondary w-50" FnOnClick={onClose} />
                        <MISButton text="Confirm" className="popup-btn right-margin10 btn btn-primary crbc-bg-color w-50" FnOnClick={() => { mutation.mutate(); }} />
                    </Stack>
                    ) : (
                        <div className="d-flex justify-content-center mt-3">
                            <Spinner animation="border" variant="info" role="status" />
                        </div>
                    )
            }
        </Stack>
    );
}
